import styled from "@emotion/styled";
import Dialog from "@mui/material/Dialog";

const StyledFaqDialog = styled(Dialog)`
  .ql-editor {
    min-height: 220px;
    max-height: 320px;
    overflow: auto;
    color: var(--cms-text-primary);
    font-size: 14px;
    line-height: 1.55;
  }

  .MuiPaper-root {
    width: min(880px, calc(100vw - 28px));
    min-height: 520px;
    border-radius: 20px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 28px 54px rgba(15, 23, 42, 0.2);
  }

  .MuiDialogTitle-root {
    padding: 20px 24px 8px;
  }

  .dialog-title-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .dialog-title {
    margin: 0;
    font-size: 22px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .dialog-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .MuiDialogContent-root {
    padding: 14px 24px 10px;
  }

  .dialog-field-group {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .MuiFormControl-root,
  .MuiTextField-root,
  .MuiOutlinedInput-root {
    width: 100%;
  }

  .MuiDialogActions-root {
    padding: 10px 24px 20px;
    gap: 10px;
  }

  .error {
    margin-top: 6px;
    font-size: 12px;
    color: #b91c1c;
    font-weight: 600;
  }

  .dialog-cancel-btn,
  .dialog-submit-btn {
    text-transform: none;
    border-radius: 10px;
    min-width: 108px;
    min-height: 40px;
    font-weight: 700;
  }

  .dialog-submit-btn {
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }
`;

const StyledFaqSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: var(--cms-surface-primary);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 500;
  }

  .page-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: var(--cms-shadow);
    padding: 14px;
  }

  .new-faq-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    min-height: 40px;
    padding: 8px 16px;
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .page-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 120px;
    border-radius: 14px;
    border: 1px dashed var(--cms-border);
    background: var(--cms-surface-muted);
    color: var(--cms-text-secondary);
    font-weight: 600;
    font-size: 14px;
  }
`;

const StyledFaqList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0;

  .faq-empty {
    border: 1px dashed var(--cms-border);
    border-radius: 14px;
    padding: 20px 14px;
    text-align: center;
    color: var(--cms-text-secondary);
    background: var(--cms-surface-muted);
    font-size: 14px;
    font-weight: 600;
  }

  .faq-item {
    position: relative;
    border: 1px solid var(--cms-border);
    border-radius: 14px;
    padding: 14px;
    background: var(--cms-surface-secondary);
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.06);
    font-size: 14px;

    .MuiChip-root {
      min-width: 80px;
      margin-right: 12px;
      border-radius: 999px;
      font-weight: 700;
      background: #edf4ff;
      color: #1e40af;
      border: 1px solid #dbe7ff;
    }

    .faq-content-session {
      display: flex;
      align-items: flex-start;
      margin: 12px 0 0;
      gap: 12px;
    }

    .faq-content {
      display: inline-block;
      line-height: 1.6;
      color: var(--cms-text-primary);
      flex: 1;
    }

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 12px;
      border-bottom: 1px solid var(--cms-border);
      padding-bottom: 10px;
    }

    .question-index {
      margin: 0;
      font-size: 17px;
      font-weight: 800;
      color: var(--cms-text-primary);
      letter-spacing: -0.01em;
    }

    .item-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;
    }

    .action-btn {
      text-transform: none;
      font-weight: 700;
      border-radius: 9px;
      min-height: 36px;
      padding: 6px 12px;
    }

    .action-btn.delete {
      color: #b91c1c;
      border-color: #fecaca;
      background: #fef2f2;
      &:hover {
        border-color: #fca5a5;
        background: #fee2e2;
      }
    }

    .faq-answer {
      width: 100%;
      overflow: hidden;
      word-break: break-word;
    }

    .faq-answer p {
      margin: 0 0 8px;
    }
  }
`;

export { StyledFaqDialog, StyledFaqSection, StyledFaqList };
